var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClass,staticStyle:{"height":"100%"}},[(!_vm.loaded)?_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"page-loading"}}):_vm._e(),(_vm.loaded && !_vm.err)?_vm._t("default"):_vm._e(),(_vm.err)?_c('error-page',{attrs:{"description":_vm.err.message || '系统繁忙，请稍后重试'}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }